import WaveSurfer from "wavesurfer.js";

export const waveSurferCleanUp = (waveSurfer: WaveSurfer) => {
  // If destroy waveform before it has loaded data, it will throw error. Therefor if the audio is not loaded yet, wait for it to load before destroying
  waveSurfer.unAll();
  if (waveSurfer.getDecodedData() === null) {
    waveSurfer.on("ready", () => {
      waveSurfer.destroy();
    });
  } else {
    waveSurfer.destroy();
  }
};
